import React, { useState } from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaSearch, FaUser, FaCalendarAlt } from 'react-icons/fa';

function Header() {
  // controle individual de dropdowns
  const [showSobre, setShowSobre] = useState(false);
  const [showProjetos, setShowProjetos] = useState(false);
  const [showDocumentos, setShowDocumentos] = useState(false);
  const logoPath = process.env.PUBLIC_URL + '/logoaapdsemfundo.png';

  return (
    <>
      {/* Barra superior */}
      <div className="bg-primary bg-gradient text-white py-2">
  <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
    <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
      <FaCalendarAlt />
      <span className="small">
        Treinamentos: Seg - Sex das 7h às 10h | 16:00h às 19:00h
      </span>
    </div>
    <div className="d-flex align-items-center gap-3">
      <a href="#" className="text-white"><FaFacebookF /></a>
      <a href="#" className="text-white"><FaInstagram /></a>
    </div>
  </Container>
</div>

      {/* Barra principal */}
      <Navbar expand="lg" bg="light" className="border-bottom shadow-sm sticky-top">
        <Container>
          {/* Logo */}
          <Navbar.Brand href="/" className="d-flex align-items-center gap-2">
            <img
              src={logoPath}
              alt="Logo AAPD"
              height="50"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto align-items-center">
              {/* Sobre - dropdown com hover */}
              <NavDropdown
                title="Sobre"
                id="sobre-dropdown"
                show={showSobre}
                onMouseEnter={() => setShowSobre(true)}
                onMouseLeave={() => setShowSobre(false)}
                className="px-2"
              >
                <NavDropdown.Item href="#sobre">História</NavDropdown.Item>
                <NavDropdown.Item href="#sobre">Missão</NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="#noticias" className="px-2 text-dark">Notícias</Nav.Link>

              {/* Projetos - dropdown com hover */}
              {/* <NavDropdown
                title="Projetos"
                id="projetos-dropdown"
                show={showProjetos}
                onMouseEnter={() => setShowProjetos(true)}
                onMouseLeave={() => setShowProjetos(false)}
                className="px-2"
              >
                <NavDropdown.Item href="#juvenil">Juvenil</NavDropdown.Item>
                <NavDropdown.Item href="#profissional">Profissional</NavDropdown.Item>
              </NavDropdown> */}

              {/* <Nav.Link href="#associados" className="px-2 text-dark">Associados</Nav.Link> */}
              <Nav.Link href="https://wa.link/nowgcg" target="_blank" className="px-2 text-dark">Doações</Nav.Link>

              {/* Documentos - dropdown com hover */}
              <NavDropdown
                title="Documentos"
                id="documentos-dropdown"
                show={showDocumentos}
                onMouseEnter={() => setShowDocumentos(true)}
                onMouseLeave={() => setShowDocumentos(false)}
                className="px-2"
              >
                <NavDropdown.Item href="/transparencia">Transparencia</NavDropdown.Item>
                {/* <NavDropdown.Item href="#relatorios">Relatórios</NavDropdown.Item> */}
              </NavDropdown>

              <Nav.Link href="/faq">FAQ</Nav.Link>

              <Nav.Link href="https://wa.link/nowgcg" target="_blank" className="px-2 text-dark">Contato</Nav.Link>

              {/* Ícone de busca */}
              {/* <Nav.Link href="#buscar" className="ps-3 text-dark">
                <FaSearch />
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
